"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TTLCache = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var node_cache_1 = __importDefault(require("node-cache"));
var TTLCache = /** @class */ (function () {
    function TTLCache() {
        this._cache = new node_cache_1.default();
    }
    // TODO: No.
    TTLCache.getInstance = function () {
        if (!TTLCache._instance) {
            TTLCache._instance = new TTLCache();
        }
        return TTLCache._instance;
    };
    TTLCache.prototype.get = function (key) {
        return this._cache.get(key);
    };
    TTLCache.prototype.set = function (key, value, ttl) {
        this._cache.set(key, value, ttl);
    };
    TTLCache.prototype.has = function (key) {
        return this._cache.has(key);
    };
    return TTLCache;
}());
exports.TTLCache = TTLCache;
//# sourceMappingURL=TTLCache.js.map